export const HEADER = "HEADER";
export const FOOTER = "FOOTER";
export const SUMMARY = "SUMMARY";
